/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { AppDispatch } from "..";
import { Tenant } from "../../models";

import { ConfigurationVariables } from "../../config";
import { tenantActions } from "./tenant-slice";
import FilterJson from "../../models/FilterJson";
import { debug } from "console";
import jwt_decode from "jwt-decode";

/////////////////////////////Get Geo Mapping
export const getGeoMapping = createAsyncThunk(
  "tenant/getGeoMapping",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<any> = await axios(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}/${ConfigurationVariables.GeoMappingAddress}`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

//////////////////////////// Get avilable Data centres
export const getAvailableDataCenters = createAsyncThunk(
  "tenant/getAvailableDataCenters",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<any> = await axios(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}/datacenters`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);
////// Get available timezones

export const getAvailableTimeZones = createAsyncThunk(
  "tenant/getAvailableTimeZones",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<any> = await axios(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}/timezones`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/// Get available currencies
export const getAvailableCurrencies = createAsyncThunk(
  "tenant/getAvailableCurrencies",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<any> = await axios(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}/currencies`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

///////////////////get Tenant logo for Tenant edit///////////
export const getTenantLogo = createAsyncThunk(
  "tenant/getTenantLogo",
  async (tenantID: string, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
          id: tenantID,
        },
      };
      const response: AxiosResponse<string> = await axios(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}/logo`,
        config
      );

      if (response.status !== 200 && response.status !== 204) {
        return rejectWithValue(response);
      }
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/////////////////// end get Tenant logo for Tenant edit///////////

/// Get available products
export const getAvailableProducts = createAsyncThunk(
  "tenant/getAvailableProducts",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<any> = await axios(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}/applications`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

// searchTenants
export const searchTenants = (searchText: string) => {
  return (dispatch: AppDispatch) => {
    dispatch(tenantActions.filerTenantsBasedOnSearchText(searchText));
  };
};
/// End code from cart-actions

/// Code from app-actions

export const sendFilteredListApp = (filteredApplications: Array<string>) => {
  return (dispatch: AppDispatch) => {
    try {
      dispatch(tenantActions.showFilteredList(filteredApplications));
    } catch (error) {}
  };
};

export const selectedApplications = (selectedApplications: Array<string>) => {
  //filteredApplications : any inside ()
  return (dispatch: AppDispatch) => {
    try {
      dispatch(
        tenantActions.filterusingselectedApplication(selectedApplications)
      );
    } catch (error) {}
  };
};

export const selectedRegions = (selectedRegion: Array<string>) => {
  //filteredRegion : any inside ()
  return (dispatch: AppDispatch) => {
    try {
      dispatch(tenantActions.filterusingselectedLocation(selectedRegion));
    } catch (error) {}
  };
};

export const sendFilteredData = (filteredData: Array<Tenant>) => {
  return (dispatch: AppDispatch) => {
    try {
      dispatch(tenantActions.createfilteredList(filteredData));
    } catch (error) {}
  };
};
/// End code from app-actions

/// Fetch tenant list
export const getTenantList = createAsyncThunk(
  "tenant/getTenantList",
  async (
    arg: {
      pageNumber: number;
      pageSize: number;
      searchText: string;
      finalFilterData: FilterJson;
    },
    { rejectWithValue }
  ) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      //
      const response: AxiosResponse<any> = await axios.post(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}/tenants?page=${arg.pageNumber}&pageSize=${arg.pageSize}&searchText=${arg.searchText}`,
        arg.finalFilterData,
        config
      );
      //
      if (response.status !== 200) {
        //
        return rejectWithValue(response);
      }

      return response.data;
    } catch (err: any) {
      //
      return rejectWithValue(err.response);
    }
  }
);

/// Fetch tenant list
export const fetchFilterCounts = createAsyncThunk(
  "tenant/fetchFilterCounts",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      //
      const response: AxiosResponse<any> = await axios.get(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}/filters`,
        config
      );
      //
      if (response.status !== 200) {
        //
        return rejectWithValue(response);
      }

      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/// Fetch tenant export list
export const getTenantExportList = createAsyncThunk(
  "tenant/getTenantExportList",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<any> = await axios.post(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}/tenants`,
        {},
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      const excelConversion = response.data.tenants.map(
        (tenant: {
          id: any;
          forgeCustomerId: any;
          tenantName: any;
          headquarterAddress: any;
          timezone: any;
          datacenter: any;
          currency: any;
          products: any[];
          organizationName: any;
          region: any;
          country: any;
          zipcode: any;
          lastUpdatedTimeStamp: any;
          createdon: any;
        }) => ({
          "Tenant ID": tenant.id,
          "Forge Customer ID": tenant.forgeCustomerId,
          "Tenant Name": tenant.tenantName,
          "Headquater Address": tenant.headquarterAddress,
          "Tenant Timezone": tenant.timezone,
          "Tenant Data Center": tenant.datacenter,
          "Tenant Currency": tenant.currency,
          "Tenant Products": tenant.products
            .map((product) => product.applicationName)
            .join(", "),
          "Organization Name": tenant.organizationName,
          "Tenant Region": tenant.region,
          "Tenant Country": tenant.country,
          "Tenant ZIP Code": tenant.zipcode === 0 ? null : tenant.zipcode,
          "Tenant Updated Time Stamp": tenant.lastUpdatedTimeStamp,
          "Created Date": tenant.createdon,
        })
      );
      return excelConversion;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);
// End Fetch Custoemr Export List

/// Edit tenant details
export const editTenantDetails = createAsyncThunk(
  "tenant/editTenantDetails",
  async (postData: any, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
          id: postData.id,
        },
      };
      const response = await axios.put(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}`,
        postData,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }
      const tenant = response.data;
      const tenantToEdit = createRequiredTenant(tenant);
      return tenantToEdit;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/// Delete tenant
export const deleteTenant = createAsyncThunk(
  "tenant/deleteTenant",
  async (id: string, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          id: id,
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response = await axios.delete(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return id;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const createTenantDetails = createAsyncThunk(
  "tenant/createTenantDetails",
  async (postData: any, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<Tenant> = await axios.post(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}`,
        postData,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }
      /// Create the tenant in known format
      const tenant = response.data;
      const tenantToAdd = createRequiredTenant(tenant);
      /// End create the tenant in known format
      return tenantToAdd;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);
//// Upload new code begin
export const uploadTenantLogoDetails = createAsyncThunk(
  "tenant/uploadTenantLogoDetails",

  async (parameters: any, { rejectWithValue }) => {
    try {
      let formData = new FormData();
      formData.append("logo", parameters.fileName);
      formData.append("id", parameters.tenantId);

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
          id: parameters.tenantId,
        },
      };
      const response = await axios.put(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}/logo`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + getAccessToken(),
            id: parameters.tenantId,
          },
        }
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/// Upload new code end
export const getAccessToken = () => {
  const accessToken: string = JSON.parse(
    sessionStorage.getItem("oidc.default") as any
  )["tokens"]["accessToken"];
  if (accessToken === undefined || accessToken === null || accessToken === "") {
    throw new Error("Access token is not in valid format");
  }
  return accessToken;
};
function createRequiredTenant(tenant: Tenant) {
  return {
    id: tenant.id,
    forgeCustomerId: tenant.forgeCustomerId,
    tenantName: tenant.tenantName,
    headquarterAddress: tenant.headquarterAddress,
    timezone: tenant.timezone,
    datacenter: tenant.datacenter,
    currency: tenant.currency,
    applications: tenant?.products?.map((product) => product.applicationId),
    organizationName: tenant.organizationName,
    region: tenant.region,
    country: tenant.country,
    zipcode: tenant.zipcode,
    lastUpdatedTimeStamp: tenant.lastUpdatedTimeStamp,
    createdon: tenant.createdon,
  };
}

/// Get List of available regions
export const getAvailableRegions = createAsyncThunk(
  "tenant/getAvailableRegions",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<any> = await axios(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/api/v1/tenant/regions`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/// Get list of avaialble Countries
export const getAvailableCountries = createAsyncThunk(
  "tenant/getAvailableCountries",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
      };
      const response: AxiosResponse<any> = await axios(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/api/v1/tenant/countries`,
        config
      );

      if (response.status !== 200) {
        return rejectWithValue(response);
      }

      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

/// Function to fetch Customer id from user token
interface UserToken {
  sub: number;
  ext: {
    customer: string;
  };
}
const isUserToken = (user: any): user is UserToken => {
  return typeof user === "object" && "sub" in user && "ext" in user;
};
//Should check condition for scenario where customer is not present in token
export const getTenantFromToken = () => {
  const tokenBearer: string = JSON.parse(
    sessionStorage.getItem("oidc.default") as any
  )["tokens"]["accessToken"];
  if (tokenBearer === undefined || tokenBearer === null || tokenBearer === "") {
    throw new Error("Access token is not in valid format");
  }
  const decode = jwt_decode(tokenBearer);
  if (!isUserToken(decode)) {
    throw new Error("invalid token object");
  }
  return decode.ext.customer;
};

/// Fetch Tenant Data for Logged in Tenant Admin Users
export const getForgeCustomeIdTenantData = createAsyncThunk(
  "tenant/getTenantDetails",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getAccessToken(),
        },
      };
      //
      const response: AxiosResponse<any> = await axios.get(
        `${ConfigurationVariables.TenantMgmt_Endpoints}/${ConfigurationVariables.Api}/${ConfigurationVariables.Version}/${ConfigurationVariables.TenantController}/${ConfigurationVariables.RouteForgeCustomerTenantDetails}`,
        config
      );
      if (response.status !== 200) {
        return rejectWithValue(response);
      }
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);
